import {Component, OnDestroy} from "@angular/core";
import {HttpErrorResponse} from "@angular/common/http";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs/internal/Subscription";
import {GjobaHttpClientService} from "src/app/data/gjoba-http-client.service";
import {Gjoba} from "src/app/models/SearchService/gjoba.model";
import {LocalStorage} from "src/app/services/local-storage";
import {ModalPaymentService} from "src/app/services/ux/modal-payment.service";
import {toastrService} from "src/app/services/ux/toastr.service";
import {WalletService} from "src/app/services/wallet.service";
import {finalize} from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

@Component({
    templateUrl: "gjoba-search.component.html"
})
export class GjobaSearchComponent implements OnDestroy {
    // #region Subscriptions
    subscription: Subscription;
    ccSubscription: Subscription;
    finishTransactionSubscription: Subscription;
    //#endregion

    searchForm: FormGroup;

    isLoading = false;

    hasParam = false;

    hasResults = false;

    private _gjobaRecords: Gjoba[];
    public get gjobaRecords(): Gjoba[] {
        return this._gjobaRecords;
    }

    public set gjobaRecords(value: Gjoba[]) {
        this._gjobaRecords = value;
        this.hasResults = !!value.length;
    }

    // * payment
    selectedInvoice: Gjoba = {} as Gjoba;
    invoiceIndex: number;

    constructor(
        private fb: FormBuilder,
        private toastr: toastrService,
        private walletService: WalletService,
        private activeRoute: ActivatedRoute,
        private modalService: ModalPaymentService,
        private ls: LocalStorage,
        private gjobaDataClient: GjobaHttpClientService,
        private translateService: TranslateService
    ) {
        this.searchForm = this.fb.group({
            plate: []
        });

        this.subscription = walletService.$walletReadyEmitter.subscribe(
            (isReady: boolean) => {
                if (isReady) {
                    this.processGjobaTransaction();
                }
            }
        );

        this.ccSubscription = walletService.$creditCardReadyEmitter.subscribe(
            (ccSelected: boolean) => {
                if (ccSelected) {
                    this.processGjobaTransaction(ccSelected);
                }
            }
        );

        this.finishTransactionSubscription = walletService.$transactionFinish.subscribe(
            (value) => {
                if (value) {
                    this.removeFinishedTransactionFromRecords();
                }
            }
        );

        this.activeRoute.params.subscribe((params: any) => {
            if (params.plate) {
                this.searchForm.controls["plate"].setValue(params.plate);

                this.hasParam = true;
                this.onSearch();
            }
        });
    }

    onSearch() {
        if (this.searchForm.value.plate == null) {
            return this.toastr.warning(this.translateService.instant("Services.FillInLicensePlateOfTheCar"));
        }

        this.isLoading = true;

        this.gjobaDataClient
            .Search(this.searchForm.value.plate)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (response: Gjoba[]) => {
                    this.gjobaRecords = response;
                },
                error: (error: HttpErrorResponse) => {
                    this.gjobaRecords = [] as Gjoba[];
                    if (
                        error.error === "gjoba_search_failed" ||
                        error.error === "search_fail"
                    ) {
                        this.toastr.warning(
                          this.translateService.instant("Services.NoSearchOnWS")
                        );
                    }

                    if (error.error === "no_invoices") {
                        this.toastr.warning(this.translateService.instant("Services.NoFineWasFound"));
                    }
                }
            });
    }

    onPay(index: number) {
        this.invoiceIndex = index;
        this.selectedInvoice = this.gjobaRecords[index];

        this.walletService.selectInvoice(this.selectedInvoice);
        this.walletService.amountOfTransaction = this.selectedInvoice.vlera + this.selectedInvoice.kamat + this.selectedInvoice.komision;

        this.modalService.open();
    }

    processGjobaTransaction(creditCardMethod: boolean = false) {
        const gjobaInvoice = {
            invoice: this.walletService.getInvoice(),
            ipAddress: "127.0.0.1",
            deviceId: "EternaWebPosta"
        };

        if (creditCardMethod) {
            this.gjobaDataClient
                .PayCC(gjobaInvoice)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: (response) => {
                        if (!response.data) {
                            this.walletService.emitTransactionProgress({
                                    isSuccess: false,
                                    error: response.error.message
                                }
                            );
                            return;
                        }
                        this.walletService.emitTransactionProgress(
                            {
                                isSuccess: true,
                                error: null
                            }
                        );
                        this.ls.set("sn", "gjoba");

                        window.location = response.data.redirect;
                    },
                    error: (error: HttpErrorResponse) => {

                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error.message
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
        } else {
            this.gjobaDataClient
                .PayWallet(gjobaInvoice)
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    })
                )
                .subscribe({
                    next: () => {
                        const emmiterObject = {
                            isSuccess: true,
                            error: null
                        };

                        this.walletService.emitTransactionProgress(emmiterObject);
                    },
                    error: (error: HttpErrorResponse) => {
                        const emmiterObject = {
                            isSuccess: false,
                            error: error.error.message
                        };
                        this.walletService.emitTransactionProgress(emmiterObject);
                    }
                });
        }
    }

    private removeFinishedTransactionFromRecords() {
        this.gjobaRecords.splice(this.invoiceIndex, 1);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.ccSubscription.unsubscribe();
        this.finishTransactionSubscription.unsubscribe();
    }
}
